export const DOCUMENT_API_URL = process.env.REACT_APP_API_BASE_URL as string;

if (!DOCUMENT_API_URL) {
  throw new Error('DOCUMENT_API_URL url is not set');
}
